import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import stylesForm from "../../Form/Form.module.css";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBirthdayCake,
    faBuilding,
    faCheck, faDownload,
    faEdit,
    faEnvelope, faExternalLink, faIdBadge,
    faIdCard,
    faLocationDot,
    faMobileAlt,
    faRemove,
    faSquareCheck,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {
    getUtilisateurRoleIcon,
    getUtilisateurRoleLabel,
    getUtilisateurStatusIcon,
    parseUtilisateurStatus
} from "../../../services/UserService";
import FieldUpload from "../../Field/FieldUpload";
import field_styles from "../../Field/Field.module.css";
import TitleSecondary from "../../Title/TitleSecondary";
import BtnSwitch from "../../Button/BtnSwitch";
import {downloadFile} from "../../../services/FileService";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";
import {Field, Form, Formik} from "formik";
import {fetchTypesActivite} from "../../../services/ActivitesService";
import BtnSave from "../../Button/BtnSave";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";


function UtilisateurVue({ mode = "consultation", utilisateur }) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [data, setData] = useState(utilisateur);
    const [myStats, setMyStats] = useState(null);
    const [myCrm, setMyCrm] = useState(null);
    const statsRef = useRef(null);
    const crmRef = useRef(null);
    const [statsLoaded, setStatsLoaded] = useState(false);
    const [crmLoaded, setCrmLoaded] = useState(false);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const fetchPost = async (url, data) => {
        try {
            const response = await AxiosConfig.post(url, data);
            setData(response.data.myUtilisateur);
            handleSuccess("Enregistré");
        } catch (error) {
            console.error('error', error);
            handleError("Erreur : "+error);
        }
    }
    const putActifOpenModal = () => {
        showModal('confirm', {
            message: "Voulez-vous vraiment supprimer cet utilisateur ?",
            onConfirm: async () => {
                await fetchPost(`/admin/utilisateurs/${data.id}/actif`, {actif: !data.actif});
            }
        });
    }

    const putCanConnectOpenModal = () => {
        let message = data.can_connect ? `Désactiver la connexion pour cet utilisateur ?` : `Permettre à cet utilisateur de se connecter ?` ;
        showModal('confirm', {
            message: message,
            onConfirm: async () => {
                await fetchPost(`/admin/utilisateurs/${data.id}/can_connect`, {can_connect: !data.can_connect});
            }
        });
    }

    const renderedFieldUploads = data?.justificatifsNeed?.map(justType => {
        const justificatif = data.justificatifs.find(just => {
            return just.type && just.type.id === justType.justId;
        });

        return (
            <FieldUpload
                key={justType.justId}
                label={justType.justLabel}
                name={`type${justType.justId}_file`}
                value={justificatif}
                data={{justificatifType: justType.justId, justificatifObligatoire: justType.justObligatoire, justificatifActif: justType.justActif}}
                titleExclamation={"Obligatoire"}
                actif={justificatif?.actif}
            />
        );
    });

    const getStats = async () => {
        if (!statsLoaded) {
            try {
                const response = await AxiosConfig.get(`/admin/utilisateurs/${data.id}/stats`);
                if (!response.data.success) {
                    return handleError("Impossible de récupérer les stats");
                }
                setMyStats(response.data.myStats);
                setStatsLoaded(true);
            } catch (error) {
                console.error('error', error);
                handleError("Erreur : "+error);
            }
        }
    }

    const getCrm = async () => {
        if (!crmLoaded) {
            try {
                const response = await AxiosConfig.get(`/admin/utilisateurs/${data.id}/crm`);
                if (!response.data.success) {
                    return handleError("Impossible de récupérer les crm");
                }
                setMyCrm(response.data.myCrm);
                setCrmLoaded(true);
            } catch (error) {
                console.error('error', error);
                handleError("Erreur : " + error);
            }
        }
    }

    const putCrmOptin = async ({target, value}) => {
        const response = await AxiosConfig.post(`/admin/crm/user_optin/${data.id}`, {
            value: value,
            target: target
        });

        if (response.data.success) {
            handleSuccess(response.data.msg);
            myCrm[target] = response.data.value;
        } else {
            handleError(response.data.msg);
        }
    }

    const handleClickFile = async (justificatif) => {
        const rez = await downloadFile(justificatif);
        if (rez.success) {
            handleSuccess(rez.message);
        } else {
            handleError(rez.message);
        }
    }

    useEffect(() => {
        if (!utilisateur || !utilisateur.id) {
            return;
        }

        setCrmLoaded(false);
        setData(utilisateur);
    }, [utilisateur]);

    useEffect(() => {
        if (!data || !data.id || (statsLoaded && crmLoaded)) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (entry.target === statsRef.current && !statsLoaded) {
                            getStats().then(() => {
                                observer.unobserve(entry.target);
                            });
                        } else if (entry.target === crmRef.current && !crmLoaded) {
                            getCrm().then(() => {
                                observer.unobserve(entry.target);
                            });
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            }
        );

        if (statsRef.current) {
            observer.observe(statsRef.current);
        }

        if (crmRef.current) {
            observer.observe(crmRef.current);
        }

        return () => {
            if (statsRef.current) {
                observer.unobserve(statsRef.current);
            }

            if (crmRef.current) {
                observer.unobserve(crmRef.current);
            }
            observer.disconnect();
        };
    }, [data, statsLoaded, crmLoaded]);

    if (!data || !data.id) {
        return <p>Chargement ...</p>;
    }

    return (
        <div>
            <div className={styles.viewBloc}>

                <div className={styles.headerBtnsVue}>
                    <button onClick={putActifOpenModal}>{data.actif ? <><FontAwesomeIcon
                        icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                        icon={faSquareCheck}/>Restaurant</>}</button>
                    <Link to={Routing.routes.adminCreation}><FontAwesomeIcon icon={faEdit}/>Modifier</Link>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <p className={styles.creerParLeBloc}>
                        Créé le {
                        DateService.formatDate(data.date_created)
                        } et mis à jour
                        le {DateService.formatDate(data.date_updated)}
                    </p>

                    <ul className={styles.listRoles}>
                        {data.roles.length === 0 ? <li>Aucun role</li> : null}
                        {data.roles.map((item, index) => (
                            <li key={index}>{getUtilisateurRoleIcon(item)} {getUtilisateurRoleLabel(item)}</li>
                        ))}

                    </ul>

                    {data.entreprise && data.entreprise.id ?
                        <div style={{marginBottom: "0"}}>
                            {/* Entreprise */}
                            <div>
                                <FontAwesomeIcon icon={faBuilding}/>
                                <span style={{marginLeft: "4px"}}>
                                    <Link to={Routing.generate({
                                        route: Routing.routes.adminEntreprise,
                                        params: { entrepriseId: data.entreprise.id }
                                    })}>{data.entreprise.nom}</Link>
                                </span>
                            </div>

                            <div>
                                <FontAwesomeIcon icon={faLocationDot}/>
                                <span style={{marginLeft: "4px"}}><a target={"_blank"}
                                                                     href={`https://www.google.com/maps/place/${encodeURI(data.entreprise.addr + " " + data.entreprise.ville + " " + data.entreprise.cp + " " + data.entreprise.pays)}`}> {data.entreprise.addr}, {data.entreprise.ville} {data.entreprise.cp} - {data.entreprise.pays}</a></span>
                            </div>
                        </div>
                        : null
                    }

                    <div>
                        <FontAwesomeIcon icon={faIdCard}/>
                        <span style={{marginLeft: "4px"}}>{data.civilite.label} {data.prenom} {data?.nom?.toUpperCase()}</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faBirthdayCake}/>
                        <span
                            style={{marginLeft: "4px"}}>né(e) le {DateService.formatDateJoli(data.date_naissance)}</span>
                    </div>

                    <div style={{marginBottom: "10px"}}>
                        <div title={"Adresse email"}>
                            <FontAwesomeIcon icon={faEnvelope} width={"16px"}/>
                            <span style={{marginLeft: "4px"}}>{data.email}</span>
                        </div>
                        <div title={"Login de connexion"}>
                            <FontAwesomeIcon icon={faIdBadge} width={"16px"}/>
                            <span style={{marginLeft: "4px"}}>{data.login}</span>
                        </div>
                        <div title={"Numéro portable"}>
                            <FontAwesomeIcon icon={faMobileAlt} width={"16px"}/>
                            <span style={{marginLeft: "4px"}}>{data.tel_mobile}</span>
                        </div>
                    </div>

                    <div style={{
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        gap: "16px",
                        alignItems: "center"
                    }}>
                        <div>
                            <div>
                                <span>Première connexion :</span>
                                <span style={{marginLeft: "4px"}}>
                                {data.date_first_conn ? DateService.formatDate(data.date_first_conn) : "Pas de donnée"}
                            </span>
                            </div>

                            <div>
                                <span>Dernière connexion :</span>
                                <span style={{marginLeft: "4px"}}>
                                    {data.date_last_conn ? DateService.formatDate(data.date_last_conn) : "Pas de donnée"}
                                </span>
                            </div>
                        </div>

                        <div style={{display: "flex", flexDirection: "row"}}>
                            <BtnSwitch
                                active={data.can_connect}
                                activeLabel={"Connexion autorisée"}
                                inactiveLabel={"Connexion interdite"}
                                onToggle={putCanConnectOpenModal}
                                classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                        </div>
                    </div>

                    <div style={{marginBottom: "10px"}}>
                        <div title={"Statut du compte"}>
                            <span>{getUtilisateurStatusIcon(data.status)} {parseUtilisateurStatus(data.status)} </span>
                        </div>

                        <div title={"Conditions générales d'utilisation"}>
                            {data.cgu ?
                                <span>A accepté les CGU {data.cgu_date && "le " + DateService.formatDate(data.cgu_date)}</span>
                                :
                                <span style={{color: "var(--clr-danger)"}}>N'a pas accepté les CGU</span>}
                        </div>
                    </div>
                </div>

                {/*
                <div>
                    <p>Lien de création et validation de compte reçu par mail : <Link to={`/profil/confirmation/${data.status}/${data.email}`}>/profil/confirmation/{data.status}/{data.email}</Link> </p>
                </div>
                */}

                <div className={styles.navLink}>
                    <Link to={Routing.generate({
                        route: Routing.routes.adminSeancesDirect,
                        queryParams: { utilisateur: data.id }
                    })}>
                        <FontAwesomeIcon icon={faExternalLink}/>
                        Séances
                    </Link>

                    <Link to={Routing.generate({
                        route: Routing.routes.adminCrmHistory,
                        queryParams: { filter_user: data.id }
                    })}>
                        <FontAwesomeIcon icon={faExternalLink}/>
                        Historique CRM
                    </Link>

                    <button className="btn" onClick={async () => {
                        const modalConfirm = showModal('confirm', {
                            message: "Voulez-vous vraiment renvoyer le mail de création de compte ?",
                            onConfirm: (async () => {
                                hideModal(modalConfirm);
                                const response = await AxiosConfig.post(`/admin/utilisateurs/${data.id}/send_mail_creation`);
                                if (response.data.success) {
                                    handleSuccess(response.data.message);
                                } else {
                                    handleError(response.data.message);
                                }
                            })
                        });
                    }}>
                        Renvoyer le mail de création de compte
                    </button>
                </div>
            </div>

            {data.roles.includes("ROLE_COACH") ?
                <div className={styles.viewBloc}>
                    <TitleSecondary text={"Types d'activités"}/>

                    <div style={{ display: "flex", flexDirection: "row", gap: "24px", flexWrap: "wrap" }}>
                        {data.activiteTypes.map((item, index) => (
                            <a  key={index} href={"/admin/activites/types/"+item.id} style={{
                                marginBottom: "10px",
                                backgroundColor: "var(--clr-bg-secondary)",
                                boxShadow: "rgba(0, 0, 0, 0.42) 0px 2px 4px",
                                borderRadius: "4px",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontWeight: "bold",
                                padding: "16px 32px"
                            }}>{item.label}</a>
                        ))}
                    </div>
                </div>
            : null}

            {data.roles.includes("ROLE_ADMIN") &&
                <div ref={statsRef} className={styles.viewBloc}>
                    <TitleSecondary text={"Entreprises administrées"}/>

                    <div style={{ display: "flex", flexDirection: "row", gap: "24px", flexWrap: "wrap" }}>
                        {data.entAdmin.map((item, index) => (
                            <a  key={index} href={"/admin/entreprises/"+item.id} style={{
                                marginBottom: "10px",
                                backgroundColor: "var(--clr-bg-secondary)",
                                boxShadow: "rgba(0, 0, 0, 0.42) 0px 2px 4px",
                                borderRadius: "4px",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontWeight: "bold",
                                padding: "16px 32px"
                            }}>{item.label}</a>
                        ))}
                    </div>
                </div>
            }

            <div className={styles.viewBloc}>
                <div className={field_styles.fieldUploadContainer}>
                    <TitleSecondary text={"Justificatifs"}/>
                    {renderedFieldUploads}
                    </div>

                    <div>
                        <h5>Historique</h5>
                        <ul>
                            {data.justificatifs.length === 0 ?
                                <li style={{fontStyle: "italic"}}>Aucun justificatif fournis</li> : null}
                            {data.justificatifs.map((item, index) => (
                                <li key={index} style={{margin: "5px 0"}}>
                                    <button className={"btn"} onClick={async () => {
                                        await handleClickFile(item)
                                    }}>
                                        <FontAwesomeIcon icon={faDownload}/>
                                    </button> <Link to={Routing.generate({
                                        route: Routing.routes.adminJustificatifsType,
                                        params: { typeId: item.type.id } }
                                    )}>
                                        {item.type.label}
                                    </Link>

                                    {item.deleted_at ? <span style={{
                                        color: "var(--clr-error)",
                                        fontSize: "var(--fs-primary)",
                                        fontStyle: "italic",
                                        marginLeft: "4px"
                                    }}>
                                        <FontAwesomeIcon icon={faRemove}/>
                                        Supprimé par <Link to={Routing.generate({
                                            route: Routing.routes.adminUtilisateur,
                                            params: { utilisateurId: item.deleted_by.id }
                                        })}>
                                            {item.deleted_by.nom}
                                        </Link> le { DateService.formatDate(item.deleted_at) }
                                    </span> : <FontAwesomeIcon icon={faCheck} style={{
                                        color: "var(--clr-success",
                                        fontSize: "var(--fs-primary)",
                                        fontStyle: "italic",
                                        marginLeft: "4px"
                                    }}/>}
                                    <p> Crée par <Link to={Routing.generate({
                                            route: Routing.routes.adminUtilisateur,
                                            params: { utilisateurId: item.created_by.id }
                                        })}>
                                            {item.created_by.nom}
                                        </Link> le {
                                            DateService.formatDate(item.created_at)
                                    } et
                                        mis à jour par <Link to={Routing.generate({
                                            route: Routing.routes.adminUtilisateur,
                                            params: { utilisateurId: item.updated_by.id }
                                        })}>
                                            {item.updated_by.nom}
                                        </Link> le { DateService.formatDate(item.updated_at) }
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>
            </div>

            <div ref={statsRef} className={styles.viewBloc}>
                <TitleSecondary text={"Statistiques"}/>

                    { myStats ? (
                        <div>
                            <div>
                                <span>Nombre de participations réelles : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_participations_reelles}</span>
                                <div>
                                    <span>Dont</span>
                                    {myStats?.types_activite?.map((item, index) => (
                                        <span key={index}> * {item.name} {item.value}</span>
                                    ))}
                                </div>
                            </div>

                            <div>
                                <span>Inscriptions : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_participations_inscriptions}</span>
                            </div>

                            <div>
                                <span>Annulées par l'utilisateur : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_participations_annulees}</span>
                            </div>

                            <div>
                                <span>En attente (actuellement) : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_participations_attente}</span>
                            </div>

                            <div>
                                <span>En attente (expirées) : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_participations_attente_expirees}</span>
                            </div>

                            <div>
                                <span>Absences : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_participations_absences}</span>
                            </div>

                            {/*
                            <div>
                                <span>Nombre de séances par semaine : </span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_cours_semaines}</span>
                            </div>
                            */}

                            <div>
                                <span>Nombre de connexions :</span>
                                <span style={{marginLeft: "4px"}}>{myStats.nb_connexions}</span>
                            </div>
                        </div>
                    ) : (
                        <p>Chargement ...</p>
                    )}
                </div>


                <div ref={crmRef} className={styles.viewBloc}>
                    <TitleSecondary text={"CRM"}/>
                    {myCrm ? (
                        <>
                            <div style={{ width: 'auto', display: "flex", flexDirection: "row", gap: "16px", justifyContent: "center" }}>
                                <div style={{ borderRadius: "15px", backgroundColor: "var(--clr-bg-secondary)", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.42)", marginBottom: "16px", padding: "10px 20px" }}>
                                    <h4 style={{ marginBottom: "10px" }}>Cours</h4>
                                    <div className={stylesForm.blocNotif}>
                                        <BtnSwitch name={"crm_optin_sms_cours"}
                                                   active={myCrm.cours_sms ?? true}
                                                   activeLabel={"SMS"}
                                                   inactiveLabel={"SMS"}
                                                   onToggle={(e) => putCrmOptin({
                                                       "target": "cours_sms",
                                                       value: !myCrm.cours_sms
                                                   })}
                                                   classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                    </div>

                                    <div className={stylesForm.blocNotif}>
                                        <BtnSwitch name={"crm_optin_email_cours"}
                                                   active={myCrm.cours_email ?? true}
                                                   activeLabel={"Mail"}
                                                   inactiveLabel={"Mail"}
                                                   onToggle={(e) => putCrmOptin({
                                                       "target": "cours_email",
                                                       value: !myCrm.cours_email
                                                   })}
                                                   classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                    </div>
                                </div>

                                <div style={{ borderRadius: "15px", backgroundColor: "var(--clr-bg-secondary)", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.42)", marginBottom: "16px", padding: "10px 20px" }}>
                                    <h4 style={{ marginBottom: "10px" }}>Relance</h4>

                                    <div className={stylesForm.blocNotif}>
                                        <BtnSwitch name={"crm_optin_sms_relances"}
                                                   active={myCrm.relance_sms ?? true}
                                                   activeLabel={"SMS"}
                                                   inactiveLabel={"SMS"}
                                                   onToggle={(e) => putCrmOptin({
                                                       "target": "relance_sms",
                                                       value: !myCrm.relance_sms
                                                   })}
                                                   classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                    </div>

                                    <div className={stylesForm.blocNotif}>
                                        <BtnSwitch name={"crm_optin_email_relances"}
                                                   active={myCrm.relance_email ?? true}
                                                   activeLabel={"Mail"}
                                                   inactiveLabel={"Mail"}
                                                   onToggle={(e) => putCrmOptin({
                                                       "target": "relance_email",
                                                       value: !myCrm.relance_email
                                                   })}
                                                   classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                    </div>
                                </div>

                            </div>
                            {myCrm.last_modif_by && <p>Dernière modif par {' '}
                                <Link to={Routing.generate({
                                    route: Routing.routes.adminUtilisateur,
                                    params: { utilisateurId: myCrm.last_modif_by.id }
                                })}>
                                    {myCrm.last_modif_by.prenom} {myCrm.last_modif_by.nom}
                                </Link>
                                {' '}le { DateService.formatDate(myCrm.last_modif_at) }
                            </p>}
                        </>
                    ) : (<p>Chargement ...</p>)}
                </div>
        </div>
    )
}

export default UtilisateurVue;